import { lazy } from "react";

export const SubmittedVideoRedirectPage = lazy(() =>
  import("./SubmittedVideoRedirectPage.jsx").then((module) => ({
    default: module.default,
  }))
);
